import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { glassTypes, glassThicknesses, coatingOptions } from '../constants';

const GlassStep = ({ config, updateConfig }) => (
  <div>
    <h3 className="text-xl font-semibold mb-6">Choose Your Glass</h3>

    <div className="mb-8">
      <h4 className="font-medium mb-3">Glass Type</h4>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {glassTypes.map((glass) => (
          <Card
            key={glass.id}
            data-testid={`glass-${glass.id}`}
            className={`cursor-pointer transition-all ${config.glassType === glass.id ? 'ring-2 ring-primary' : 'hover:ring-1 hover:ring-primary/50'}`}
            onClick={() => updateConfig('glassType', glass.id)}
          >
            <CardContent className="p-4">
              <h5 className="font-semibold">{glass.name}</h5>
              <p className="text-xs text-muted-foreground">{glass.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>

    <div className="mb-8">
      <h4 className="font-medium mb-3">Glass Thickness</h4>
      <div className="flex gap-4">
        {glassThicknesses.map((thickness) => (
          <Card
            key={thickness.id}
            data-testid={`thickness-${thickness.id}`}
            className={`cursor-pointer flex-1 transition-all ${config.glassThickness === thickness.id ? 'ring-2 ring-primary' : 'hover:ring-1 hover:ring-primary/50'}`}
            onClick={() => updateConfig('glassThickness', thickness.id)}
          >
            <CardContent className="p-4 text-center">
              <h5 className="text-2xl font-bold text-primary">{thickness.name}</h5>
              <p className="text-xs text-muted-foreground">{thickness.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>

    <div>
      <h4 className="font-medium mb-3">Protective Coating</h4>
      <div className="grid md:grid-cols-2 gap-4">
        {coatingOptions.map((coat) => (
          <Card
            key={coat.id}
            data-testid={`coating-${coat.id}`}
            className={`cursor-pointer transition-all ${config.coating === coat.id ? 'ring-2 ring-primary' : 'hover:ring-1 hover:ring-primary/50'}`}
            onClick={() => updateConfig('coating', coat.id)}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h5 className="font-semibold">{coat.name}</h5>
                  <p className="text-xs text-muted-foreground">{coat.description}</p>
                </div>
                {coat.id === 'showerguard' && (
                  <Badge className="bg-primary/10 text-primary">Recommended</Badge>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </div>
);

export default GlassStep;
